import clsx from "clsx";
import { cva, VariantProps } from "cva";

import styles from "./index.module.css";

export const variants = cva({
  base: styles.base,
  variants: {
    type: {
      basic: styles.basic,
      weakest: styles.weakest,
    },
    color: {
      "accent-primary": styles.accent_primary,
      "accent-secondary": styles.accent_secondary,
      "accent-tertiary": styles.accent_tertiary,
      notice: styles.notice,
      caution: styles.caution,
      weak: styles.weak,
    },
    fontSize: {
      xs: styles.font_size_xs,
      m: styles.font_size_m,
    },
    fontWeight: {
      normal: styles.font_weight_normal,
      bold: styles.font_weight_bold,
    },
  },
  defaultVariants: {
    type: "basic",
    fontSize: "m",
    fontWeight: "normal",
  },
});

export type ChipProps = { text: string; className?: string; role?: string } & VariantProps<typeof variants>;

export const Chip = ({ type, color, fontSize, fontWeight, text, className, role }: ChipProps) => (
  <span role={role} className={clsx(variants({ type, color, fontSize, fontWeight }), className)}>
    {text}
  </span>
);
